import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const displayValue = (value) => {
  return value === undefined || value === null || value === '' ? '—' : value;
};

function DetailItem({ label, value }) {
  return (
    <div className="supplier-detail-item">
      <dt className="supplier-detail-item__label">{label}</dt>
      <dd className="supplier-detail-item__value">{displayValue(value)}</dd>
    </div>
  );
}

DetailItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

DetailItem.defaultProps = {
  value: '',
};

export default function SupplierBasicInformation(props) {
  const { supplierData } = props;
  const hasLogo = typeof supplierData.logoUrl === 'string' && /^https?:\/\//i.test(supplierData.logoUrl);

  return (
    <div className="supplier-profile">
      <section className="supplier-profile__section supplier-profile__section--wide">
        <header className="supplier-section__header">
          <h3 className="supplier-section__title">Organisation</h3>
          <p className="supplier-section__description">
            The supplier name, main contact number, and assigned tier.
          </p>
        </header>
        <dl className="supplier-detail-grid supplier-detail-grid--three">
          <DetailItem label="Company name" value={supplierData.companyName} />
          <DetailItem label="Main phone" value={supplierData.mainTelephone} />
          <DetailItem label="Tier" value={supplierData.tier} />
        </dl>
      </section>

      <section className="supplier-profile__section">
        <header className="supplier-section__header">
          <h3 className="supplier-section__title">Address</h3>
          <p className="supplier-section__description">
            Registered or primary business address.
          </p>
        </header>
        <dl className="supplier-detail-grid">
          <DetailItem label="Address line 1" value={supplierData.address1} />
          <DetailItem label="Address line 2" value={supplierData.address2} />
          <DetailItem label="City" value={supplierData.city} />
          <DetailItem label="County" value={supplierData.county} />
          <DetailItem label="Postcode" value={supplierData.postcode} />
        </dl>
      </section>

      <section className="supplier-profile__section">
        <header className="supplier-section__header">
          <h3 className="supplier-section__title">Registration and brand</h3>
          <p className="supplier-section__description">
            Business identifiers and supplier logo.
          </p>
        </header>
        <dl className="supplier-detail-grid">
          <DetailItem label="Company number" value={supplierData.companyNumber} />
          <DetailItem label="VAT number" value={supplierData.vatNumber} />
        </dl>
        <div className="supplier-logo-preview">
          {hasLogo ?
            <img src={supplierData.logoUrl} alt={`${supplierData.companyName || 'Supplier'} logo`} /> :
            'No logo provided'
          }
        </div>
      </section>
    </div>
  );
}

const { object } = PropTypes;

SupplierBasicInformation.propTypes = {
  supplierData: object,
};

SupplierBasicInformation.defaultProps = {
  supplierData: {},
};
